export default __webpack_public_path__ + "static/media/Avion Travel.8fa42b17.jpg";